import React from 'react';
import PropTypes from 'prop-types';
import WorkshopList from './list/WorkshopList';
import { getString } from '../../utils';
import BlockHeader from '../BlockHeader';
import WorkshopsWithRegistrationBlock from '../../home/blocks/WorkshopsWithRegistrationBlock';

const translationPrefix = 'blocks';

const gridTemplates = {
  grid: WorkshopList,
  registration: WorkshopsWithRegistrationBlock,
};

const WorkshopsBlock = ({ workshopList, header, headerKey, itemProps, template }) => {
  const GridComponent = gridTemplates[itemProps?.gridTemplate] || gridTemplates.grid;
  return (
    <>
      <BlockHeader title={header || getString(headerKey)} />
      <GridComponent
        centered
        workshopList={workshopList}
        itemProps={itemProps}
        template={template || itemProps}
        collection="workshops"
      />
    </>
  );
};

WorkshopsBlock.defaultProps = {
  header: undefined,
  headerKey: `${translationPrefix}.sessions`,
  itemProps: undefined,
  template: undefined,
};

WorkshopsBlock.propTypes = {
  header: PropTypes.string,
  headerKey: PropTypes.string,
  itemProps: PropTypes.object,
  template: PropTypes.object,
  workshopList: PropTypes.array.isRequired,
};

export default WorkshopsBlock;
